import { injectIntl } from 'react-intl';
import { formatI18n } from '../I18n/I18n/I18n';
import React, { useContext, useEffect } from 'react';
import { TitleContext, TitleNestContext } from '../TitleContext';
function DocumentTitle(_ref) {
  var intl = _ref.intl,
    i18n = _ref.i18n,
    children = _ref.children;
  var dispatch = useContext(TitleContext);
  var level = useContext(TitleNestContext);
  if (!dispatch) {
    throw new Error('DocumentTitle must be called within a TitleContext Provider');
  }
  var title = formatI18n(intl, i18n) || '';
  useEffect(function () {
    if (title) {
      dispatch({
        type: 'add',
        payload: {
          level: level,
          title: title
        }
      });
    }
    return function () {
      dispatch({
        type: 'remove',
        payload: {
          level: level
        }
      });
    };
  }, [level, dispatch, title]);
  return /*#__PURE__*/React.createElement(TitleNestContext.Provider, {
    value: level + 1
  }, children);
}
export default injectIntl(DocumentTitle);